import BaseObject from '../../base/base_object';
import ReadRealGameConfigurationGameStep from '../game/game_steps/game_configuration_reading/read_real_game_configuration_gamestep';
import ReadAnonymousGameConfigurationGameStep from '../game/game_steps/game_configuration_reading/read_anonymous_game_configuration_gamestep';
import ReadHistoryGameConfigurationGameStep from '../game/game_steps/game_configuration_reading/read_history_game_configuration_gamestep';
import VoidGamePostMessageListener from '../game/post_messages/void_game_post_message_listener';
import FreePlayConfirmationGameStep from '../game/game_steps/free_play_confirmation/free_play_confirmation_gamestep';
import ServiceFactory from '../service_factory';
import GameSequenceBuilder from '../game/game_sequence_builder/game_sequence_builder';
import BuildFullScreenTapGameStep from "../game/game_steps/launch_game/build_full_screen_tap_gamestep";
import BonusAbusePreventionGameStep from "../game/game_steps/bonus_abuse_prevention_gamestep";
import WaitForHybridGameStep from "../game/game_steps/wait_for_hybrid_gamestep";
import {ILocalizedGameInfo} from '../games_information/games_information_service_interface';
import {GAME_GROUP} from '../../../../common/const/game_groups_consts';
import {GamingHistoryRecordRawData} from "../../../../app-react/services/gaming-history/gaming-history.service.interfce";



export default class CompanyBase extends BaseObject {
  static CLASS = 'CompanyBase';
  serviceFactory: ServiceFactory;
  companyName: string;

  init(params) {
    if (!params.serviceFactory) {
      this.throwArgumentExpected('25', 'init', 'serviceFactory');
    }
    this.serviceFactory = params.serviceFactory;
    this.companyName = params.companyName;
  }

  getRealGameSequenceBuilder(gameOptions, gameSequenceBuilder: GameSequenceBuilder) {
      let builder: GameSequenceBuilder = gameSequenceBuilder.insert(FreePlayConfirmationGameStep).last();
      if (this.serviceFactory.gameService().isBonusAbusePreventionEnabled()){
          builder = builder.insert(BonusAbusePreventionGameStep).last();
      }
      builder = builder.insert(ReadRealGameConfigurationGameStep).last()
        .insert(BuildFullScreenTapGameStep).last();

      return builder;
  }

  insertWaitForHybridGameStep(gameSequenceBuilder, beforeGameStep, folderstruct, foldershared){
    return gameSequenceBuilder.insert(WaitForHybridGameStep,{folderStruct: folderstruct, sharedFolder: foldershared}).before(beforeGameStep);
  }

  

  getAnonymousGameSequenceBuilder(gameOptions, gameSequenceBuilder) {
    return gameSequenceBuilder
        .insert(ReadAnonymousGameConfigurationGameStep).last()
        .insert(BuildFullScreenTapGameStep).last();
  }

  getHistoryGameSequenceBuilder(gameOptions, gameSequenceBuilder) {
    return gameSequenceBuilder.insert(ReadHistoryGameConfigurationGameStep).last();
  }

  getGamePostMessageListener(gameOptions) {
    return Promise.resolve(VoidGamePostMessageListener.create());
  }

  shouldShowRealityCheckMessageWhileGameIsOpen() {
    return false;
  }

  shouldShowTimeLimitMessageWhileGameIsOpen() {
    return false;
  }

  stopGameAutoPlay(gameOptions) { }

  continueGamePlay(gameOptions) { }

  _sendMessageToGame(gameOptions, postMessageData) {
    if (gameOptions.gameBody) {
      gameOptions.gameBody.sendMessageToGame(postMessageData);
    }
  }

  getRealityCheckIntervalExpectedByTheGame() {
    return this.serviceFactory.regulationService().getRealityCheckIntervalExpectedByTheGame();
  }

  getCustomBodyClasses(gameOptions) {
    return [];
  }

  supportsHistoryMoreDetails(historyRecord: GamingHistoryRecordRawData) {
    return true;
  }

  sendRefreshBalanceCommand(gameOptions) {
  }

  supportsRefreshBalance() {
    return false;
  }

  allowDemoForGame(gameInfo: ILocalizedGameInfo): boolean {
    if (gameInfo.gameGroupId === GAME_GROUP.LIVE_CASINO) {
      return false;
    }

    return true;
  }
}
